import {
    DELETE_NON_VERIFIED, DELETE_VERIFIED, DISABLE_VERIFIED_API,
    GET_VERIFIED_LIST,
    GET_VERIFIED_VIEW_LIST,
} from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";

export const getVerifieddataList = (
  roletype,
  perPage,
  currentPage,
  searchData,
  selectedDistrictId,
  selectedCategory,
  selectedSubCategoryId,
  selectedSportId,
  selectedInsitutionCategoryId,
  orgselectedCategory,
  selectedGender,
  selectedKitSize = "",
  selectedShoeSize = "",
  selectedLevelOfAchievement = ""
) => {
  return ApiService.get(
    `${GET_VERIFIED_LIST}/${roletype}?number=${perPage}&page=${currentPage}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}&org_id=${selectedInsitutionCategoryId}&org_type=${orgselectedCategory}&gender=${selectedGender}&kit_size=${selectedKitSize || ""}&shoe_size=${selectedShoeSize || ""}&level_of_achievement=${selectedLevelOfAchievement || ""}`
  );
};

export const getAlldataverifiedDwnload = (typeId, Id) => {
  return ApiService.get(`${GET_VERIFIED_LIST}/${typeId}`);
};

export const getVerifieddataInsitutionList = (roletype, perPage, currentPage,searchData,selectedDistrictId,selectedCategory,selectedSubCategoryId,selectedSportId) => {
  return ApiService.get(
    `${GET_VERIFIED_LIST}/${roletype}?number=${perPage}&page=${currentPage}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`
  );
};

export const getVerfiedViewByID = (typeId, Id) => {
  return ApiService.get(`${GET_VERIFIED_VIEW_LIST}${typeId}/${Id}`);
};
// verified Delete API

export const  deleteVerifiedUserData  = (data) => {
    return ApiService.post(DELETE_VERIFIED,data);
}

export const  disableVerifiedUserData  = (data) => {
    return ApiService.post(DISABLE_VERIFIED_API,data);
}
